//Run in Server

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import NavigationBar from "./Components/NavigationBar";
import Dashboard from "./Pages/All Users/Dashboard";
import ApplicationForm from "./Pages/Applicant/ApplicationForm";
import Login from "./Pages/All Users/Login";
import AwardApplications from "./Pages/Director/AwardApplications";
import Footer from "./Components/Footer";
import SignUp from "./Pages/All Users/SignUp";
import ApplicationTemplates from "./Pages/Applicant/ApplicationTemplates"; 
import Home from "./Pages/All Users/Home";
import SubmittedApplications from "./Pages/Applicant/SubmittedApplications";  
import ShortlistApplications from "./Pages/Director/ShortlistApplications";
import ForgotPassword from "./Pages/All Users/ForgotPassword"; 
import ChangePassword from "./Pages/All Users/ChangePassword"; 
import SubmittedapplicationsD from "./Pages/Director/SubmittedApplicationsD";
import ApproveAwards from "./Pages/Director/ApproveAwards";  
import SendEmailDean from "./Pages/Director/SendEmailDean"; 
import SendEmailApplicant from "./Pages/Director/SendEmailApplicant"; 
import DeanApproval from "./Pages/Dean/DeanApproval"; 
import Apc from "./Pages/Director/Apc";
import ApcApplications from "./Pages/Applicant/ApcApplications";
import AllApplicationDetails from "./Pages/Director/AllApplicationDetails";
import BursarApprove from "./Pages/Bursar/BursarApprove";
import SendEmailBursar from "./Pages/Director/SendEmailBursar";
import SendCompletedApplications from "./Pages/Director/SendCompletedApplications";
import Profile from "./Pages/All Users/Profile"; 
import FinalApplications from "./Pages/Director/FinalApplications";
import ApplicationDates from "./Pages/Director/ApplicationDates";
import CreateAccount from "./Pages/Director/CreateAccount"; 
import ApproveAwardsMC from "./Pages/Director/ApproveAwardsMC"; // Import the new component
import SendEmailMC from "./Pages/Director/SendEmailMC"; // Import the new component
import McMemberApprove from "./Pages/MCMember/McMemberApprove"; // Import the new component
import ApproveApplicationURC from "./Pages/Director/ApproveApplicationURC"

function App() {
  return (
    <BrowserRouter basename="/AMS">
      
      <Routes>
        
        <Route path="/" element={<Home />} />  
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/applicationform" element={<ApplicationForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/awardapplications" element={<AwardApplications />} />
        <Route path="/applicationtemplates" element={<ApplicationTemplates />} />  {/* Corrected typo here */}
        {/* Redirect Home route if necessary */}
        <Route path="/home" element={<Navigate to="/" />} />  {/* Redirect to Home */}
        <Route path="/submittedapplications" element={<SubmittedApplications />} />
        <Route path="/shorlistapplications" element={<ShortlistApplications/>}/>
        <Route path="/forgotpassword" element={<ForgotPassword />}/>
        <Route path="/changepassword" element={<ChangePassword />}/>
        <Route path="submittedapplicationsd" element={<SubmittedapplicationsD />} />
        <Route path="approveawards" element={<ApproveAwards />} />
        <Route path ="sendemaildean" element={<SendEmailDean />} />
        <Route path="/sendemailapplicant" element={<SendEmailApplicant />} /> 
        <Route path="/deanapproval" element={<DeanApproval />} />
        <Route path="/apc" element={<Apc />} />
        <Route path="/apcapplications" element={<ApcApplications />} />
        <Route path="/allapplicationDetails" element={<AllApplicationDetails />} />
        <Route path="/bursarapprove" element={<BursarApprove />} />
        <Route path="/sendemailbursar" element={<SendEmailBursar/>}/>
        <Route path="/sendcompletedapplications" element={< SendCompletedApplications/>}/>
        <Route path="/approveawardsmc" element={<ApproveAwardsMC />} />
        <Route path="/sendemailmc" element={<SendEmailMC />} />
        <Route path="/mcmemberapprove" element={<McMemberApprove />} />
        <Route path="/approveapplicationurc" element={<ApproveApplicationURC />} />
        <Route path="/profile" element={<Profile/>}/>
        <Route path="/finalapplications" element={<FinalApplications />} />
        <Route path="/createaccount" element={<CreateAccount />} />
        <Route path="/applicationdates" element={<ApplicationDates />} /> 

      </Routes>
      <Footer /> 
    </BrowserRouter>
  );
}
export default App;




// // Run in Localhost

// import React from "react";
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';

// import NavigationBar from "./Components/NavigationBar";
// import Dashboard from "./Pages/All Users/Dashboard";
// import ApplicationForm from "./Pages/Applicant/ApplicationForm";
// import Login from "./Pages/All Users/Login";
// import AwardApplications from "./Pages/Director/AwardApplications";
// import Footer from "./Components/Footer";
// import SignUp from "./Pages/All Users/SignUp";
// import ApplicationTemplates from "./Pages/Applicant/ApplicationTemplates"; 
// import Home from "./Pages/All Users/Home";
// import SubmittedApplications from "./Pages/Applicant/SubmittedApplications";  
// import ShortlistApplications from "./Pages/Director/ShortlistApplications";
// import ForgotPassword from "./Pages/All Users/ForgotPassword"; 
// import ChangePassword from "./Pages/All Users/ChangePassword"; 
// import SubmittedapplicationsD from "./Pages/Director/SubmittedApplicationsD";
// import ApproveAwards from "./Pages/Director/ApproveAwards";  
// import SendEmailDean from "./Pages/Director/SendEmailDean"; 
// import SendEmailApplicant from "./Pages/Director/SendEmailApplicant"; 
// import DeanApproval from "./Pages/Dean/DeanApproval"; 
// import Apc from "./Pages/Director/Apc";
// import ApcApplications from "./Pages/Applicant/ApcApplications";
// import AllApplicationDetails from "./Pages/Director/AllApplicationDetails";
// import BursarApprove from "./Pages/Bursar/BursarApprove";
// import SendEmailBursar from "./Pages/Director/SendEmailBursar";
// import SendCompletedApplications from "./Pages/Director/SendCompletedApplications";
// import Profile from "./Pages/All Users/Profile"; 
// import FinalApplications from "./Pages/Director/FinalApplications";
// import ApplicationDates from "./Pages/Director/ApplicationDates";
// import CreateAccount from "./Pages/Director/CreateAccount"; 
// import ApproveAwardsMC from "./Pages/Director/ApproveAwardsMC"; // Import the new component
// import SendEmailMC from "./Pages/Director/SendEmailMC"; // Import the new component
// import McMemberApprove from "./Pages/MCMember/McMemberApprove"; // Import the new component
// import ApproveApplicationURC from "./Pages/Director/ApproveApplicationURC"

// function App() {
//   return (
//     <BrowserRouter>
      
//       <Routes>
//         <Route path="/" element={<Home />} />  
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/applicationform" element={<ApplicationForm />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<SignUp />} />
//         <Route path="/awardapplications" element={<AwardApplications />} />
//         <Route path="/applicationtemplates" element={<ApplicationTemplates />} />  {/* Corrected typo here */}
//         {/* Redirect Home route if necessary */}
//         <Route path="/home" element={<Navigate to="/" />} />  {/* Redirect to Home */}
//         <Route path="/submittedapplications" element={<SubmittedApplications />} />
//         <Route path="/shorlistapplications" element={<ShortlistApplications/>}/>
//         <Route path="/forgotpassword" element={<ForgotPassword />}/>
//         <Route path="/changepassword" element={<ChangePassword />}/>
//         <Route path="submittedapplicationsd" element={<SubmittedapplicationsD />} />
//         <Route path="approveawards" element={<ApproveAwards />} />
//         <Route path ="sendemaildean" element={<SendEmailDean />} />
//         <Route path="/sendemailapplicant" element={<SendEmailApplicant />} /> 
//         <Route path="/deanapproval" element={<DeanApproval />} />
//         <Route path="/apc" element={<Apc />} />
//         <Route path="/apcapplications" element={<ApcApplications />} />
//         <Route path="/allapplicationDetails" element={<AllApplicationDetails />} />
//         <Route path="/bursarapprove" element={<BursarApprove />} />
//         <Route path="/sendemailbursar" element={<SendEmailBursar/>}/>
//         <Route path="/sendcompletedapplications" element={< SendCompletedApplications/>}/>
//         <Route path="/approveawardsmc" element={<ApproveAwardsMC />} />
//         <Route path="/sendemailmc" element={<SendEmailMC />} />
//         <Route path="/mcmemberapprove" element={<McMemberApprove />} />
//         <Route path="/approveapplicationurc" element={<ApproveApplicationURC />} />
//         <Route path="/profile" element={<Profile/>}/>
//         <Route path="/finalapplications" element={<FinalApplications />} />
//         <Route path="/applicationdates" element={<ApplicationDates />} />
//         <Route path="/createaccount" element={<CreateAccount />} />

//       </Routes>
//       <Footer /> 
//     </BrowserRouter>
//   );
// }
// export default App;
